export default "__VITE_ASSET__hBHI37vu__"